import { useState } from "react";
import { Button, Col, Container, Image, Modal, Row } from "react-bootstrap";
import logo from '../../../assets/logo_stride.png';
import { AuthActionEnum } from "../../../enums/app.enum";
import CloseIcon from "../close-icon/close-icon.component";
import '../login-modal/login-modal.component.scss';
import TermConditionModal from '../term-condition-modal/term-condition-modal.component';

/**
 * Modal delect
 * @param {*} props Modal props
 * @param {*} props.onHide callback function when close modal
 * @returns
 */
const SignupModal = (props: any) => {
  const [showTC, setshowTC] = useState(false)

  const handleSignupByEmail = () => {
    props.onHide(AuthActionEnum.OPEN_SIGN_UP_BY_EMAIL)
  }

  const handleOpenLogin = () => {
    props.onHide(AuthActionEnum.OPEN_LOGIN)
  }

  return (
    <Modal {...props} animation={false} centered>
      <Modal.Body className="text-center text-14">
        <CloseIcon onClicked={props.onHide} />
        <Container>
          <Row>
            <Col>
              <Image src={logo} className="my-4"  style={{ width: 'inherit' }}/>
              <p>
                By registering to this website, you accept our <span className='text-primary pointer fw-7' onClick={() => setshowTC(true)}>Terms of Use </span>
                and our <span className='text-primary pointer fw-7' onClick={() => setshowTC(true)}>Privacy Policy</span>
              </p>
              <div className="d-flex flex-column justify-content-center px-md-6">
                <Button variant='danger' block className="mt-2 py-2 btn-signup" onClick={handleSignupByEmail}>Sign up with email</Button>
              </div>
              <div className='text-center mt-4'><i>Your booking information will be saved to yọur new account</i></div>
              <div className="d-flex justify-content-center mb-4 mt-2 fw-6" style={{color: '#A6A6A6'}}>
                Already had an account?&nbsp;
                <span className='text-primary pointer fw-7' onClick={handleOpenLogin}>Login</span>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      {showTC && <TermConditionModal show={showTC} onHide={() => setshowTC(false)} onOk={() => setshowTC(false)} />}
    </Modal >
  );
}

export default SignupModal;
